<template>
	<div class="nav-bar">
		<div class="nav-top">
			<img class="head-logo" @click="goMain" src="http://cfes.oss-cn-beijing.aliyuncs.com/img/logo2.png" alt="LOGO" />
			<div class="right-menu">
				<i class="iconfont icon-caidan" @click="toggle"></i>
				<ul class="head-nav" v-show="isShow" :style="{opacity: isToggled?1:0}">
					<li :class="routeName == 'mIndex' && 'active'" @click="goMain">首页</li>
					<li v-for="item in caseList" :key="item.id" @click="goCasePage(item.id)"
						:class="caseId == item.id && 'active'">
						<a href="javascript:;">{{item.name.split("：")[0]}}</a>
					</li>
				</ul>
			</div>
		</div>
		<div class="menu-mask" v-show="isShow" @click="toggle" :style="{opacity: isToggled?1:0}"></div>
	</div>
</template>

<script>
	import {
		ajaxGet
	} from '@/utils/ajax.js';
	import {
		EventBus
	} from "@/utils/event-bus.js";
	export default {
		name: "navbar",
		components: {},
		data() {
			return {
				isShow: false,
				isToggled: false,
				caseList: [],
				routeName: "mIndex",
				caseId: "",
			}
		},
		created() {
			this.routeName = this.$route.name;
			ajaxGet('/type_list').then(res => {
				let caseList = res.data.typeData.find(item => item.id === 4).child;
				this.caseList = caseList;
				console.log(JSON.parse(JSON.stringify(caseList)));
				// this.$store.dispatch('setCaseList', caseList);
			})
		},
		mounted() {},
		computed: {},
		watch: {
			'$route'(to, from) {
				this.routeName = to.name;
				this.caseId = to.query.id;
				if (this.routeName == "mCase" && this.caseId) {
					EventBus.$emit("setCaseId", this.caseId);
				}
			}
		},
		methods: {
			goMain() { // 点击LOGO回到首页
				if (this.routeName != "mIndex") {
					if (this.isShow) this.toggle();
					this.$router.push('/mIndex');
				}
			},
			toggle() {
				if (this.isShow) {
					this.isToggled = false;
					setTimeout(_ => {
						this.isShow = false;
					}, 300)
				} else {
					this.isShow = true;
					setTimeout(_ => {
						this.isToggled = true;
					}, 0)
				}
			},
			goCasePage(id) {
				if (this.isShow) this.toggle();
				this.$router.push({
					path: '/mCase',
					query: {
						id: id
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.nav-bar {
		width: 100%;

		.nav-top {
      padding: 0px 20px 0px 40px;
			background-color: #040000;
			color: #FFF;
			height: 55px;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			position: fixed;
			top: 0;
			left: 0;
			z-index: 999;

			.head-logo {
				width: 120px;
			}

			.right-menu {

				.icon-caidan {
					font-size: 26px;
					color: #FF6600;
				}

				.head-nav {
					position: fixed;
					right: 0;
					top: 55px;
					padding: 5px 20px;
					background-color: #040000;
					text-align: center;
					line-height: 28px;
					font-size: 14px;
					transition: opacity 300ms;

					li.active {
						color: #FF6600;
					}
				}
			}
		}

		.menu-mask {
			position: fixed;
			top: 0;
			height: 100%;
			width: 100%;
			left: 0;
			background-color: rgba(0, 0, 0, 0.3);
			transition: opacity 300ms;
			z-index: 995;
		}
	}
</style>